import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { usePortalsManager } from '../../utilities/portals/hooks.js';
import { useUniqueId } from '../../utilities/unique-id/hooks.js';

function Portal(_ref) {
  var children = _ref.children,
      _ref$idPrefix = _ref.idPrefix,
      idPrefix = _ref$idPrefix === void 0 ? '' : _ref$idPrefix,
      _ref$onPortalCreated = _ref.onPortalCreated,
      onPortalCreated = _ref$onPortalCreated === void 0 ? noop : _ref$onPortalCreated;

  var _usePortalsManager = usePortalsManager(),
      container = _usePortalsManager.container;

  var uniqueId = useUniqueId('portal');
  var portalId = idPrefix !== '' ? "".concat(idPrefix, "-").concat(uniqueId) : uniqueId;
  useEffect(function () {
    onPortalCreated();
  }, [onPortalCreated]);
  return container ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    "data-portal-id": portalId
  }, children), container) : null;
}

function noop() {}

export { Portal };